import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { BlogArticle } from '@/mocks/blogData';

interface BlogArticleCardProps {
  article: BlogArticle;
}

export default function BlogArticleCard({ article }: BlogArticleCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/blog/${article.slug}`}
      className="card-glow bg-background-50 border border-background-200/60 group cursor-pointer flex flex-col"
    >
      {/* Thumbnail */}
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col flex-1">
        {/* Meta */}
        <div className="flex items-center gap-3 mb-3">
          <span className="text-[12px] tracking-[0.08em] text-accent-600 bg-accent-100/70 px-2.5 py-1 whitespace-nowrap">
            {t(`blog.cat.${article.categoryId}`, { defaultValue: article.category })}
          </span>
          <span className="text-[13px] text-foreground-500 tracking-[0.04em]">{article.date}</span>
        </div>

        {/* Title — article body text is backlog; ja text shown */}
        <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-2.5 leading-snug group-hover:text-accent-600 transition-colors duration-300 line-clamp-2">
          {article.title}
        </h3>

        {/* Excerpt — article body text is backlog; ja text shown */}
        <p className="text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em] line-clamp-2 flex-1">
          {article.excerpt}
        </p>

        {/* Read more */}
        <span className="inline-flex items-center gap-1.5 mt-4 text-[13px] text-accent-600 tracking-[0.08em]">
          <span>{t('blog.list.readMore')}</span>
          <i className="ri-arrow-right-line text-[12px] transition-transform duration-300 group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}